import { render, staticRenderFns } from "./ShowObjectStore.vue?vue&type=template&id=680407ec"
import script from "./ShowObjectStore.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowObjectStore.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports